"use strict";

const style = require('!!css-loader?{"sourceMap":false}!postcss-loader!./style/index.css').default;

module.exports =`
    <style>${style}</style>
    <div class="label-container"><label></label></div>
    <div class="swiftref-dropdown js-select">
      <div aria-controls="listbox"
           aria-expanded="false"
           aria-haspopup="listbox"
           aria-labelledby="custom drop down widget"
           role="combobox"
           tabindex="0"></div>
      <div role="listbox"
           aria-labelledby="dropdown list"
           tabindex="-1">
      </div>
    </div>
   <swiftref-message></swiftref-message> 
    
`;
